// extracted by mini-css-extract-plugin
export var box = "_8z-1";
export var checkboxRow = "_8z-8";
export var checked = "_8z-2";
export var descriptionSpacer = "_8z-a";
export var disabled = "_8z-3";
export var icon = "_8z-6";
export var input = "_8z-0";
export var labelSpacer = "_8z-9";
export var medium = "_8z-5";
export var small = "_8z-4";
export var text = "_8z-7";